import type { PhotoModalImage } from "@/components/ui/photo-modal";
import type { GalleryDress } from "@/types/gallery";

interface GalleryHeroImage {
  url: string | null;
  alt: string;
}

function addImage(
  images: PhotoModalImage[],
  seen: Set<string>,
  image: PhotoModalImage | null
) {
  if (!image?.src || image.src.trim().length === 0 || seen.has(image.src)) {
    return;
  }

  seen.add(image.src);
  images.push(image);
}

export function getGalleryPhotoImages(
  dress: GalleryDress,
  heroImage?: GalleryHeroImage
): PhotoModalImage[] {
  const images: PhotoModalImage[] = [];
  const seen = new Set<string>();
  const fallbackName = dress.title || dress.prompt || "Gallery dress";

  if (heroImage?.url) {
    addImage(images, seen, {
      id: `hero-${heroImage.url}`,
      src: heroImage.url,
      alt: heroImage.alt,
    });
  }

  addImage(images, seen, {
    id: "front",
    src: dress.image_url || "",
    alt: `${fallbackName} - front view`,
  });

  addImage(images, seen, {
    id: "back",
    src: dress.back_image_url || "",
    alt: `${fallbackName} - back view`,
  });

  (dress.lifestyle_images ?? [])
    .slice()
    .sort((a, b) => a.sort_order - b.sort_order)
    .forEach((image, index) => {
      addImage(images, seen, {
        id: image.id || `lifestyle-${index}`,
        src: image.image_url,
        alt: image.label
          ? `${fallbackName} - ${image.label.replace(/[_-]+/g, " ")}`
          : `${fallbackName} - lifestyle image ${index + 1}`,
      });
    });

  return images;
}
